<template>
  <div>
    <h5 style="text-align: center;">退出登录</h5>
    <el-button type="danger" @click="confirmLogout" style="text-align: center;">退出登录</el-button>
  </div>
</template>

<script>
import { ElMessageBox, ElMessage } from 'element-plus';
import axios from 'axios';

export default {
  name: 'LogoutComponent',
  methods: {
    confirmLogout() {
      ElMessageBox.confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.post('/api/logout')
          .then(response => {
            if (response.data.message === 'Logout successful') {
              ElMessage({
                type: 'success',
                message: '退出登录成功',
              });
              // 成功后跳转到登录页
              this.$router.push('/login');
            } else {
              ElMessage({
                type: 'error',
                message: '退出登录失败',
              });
            }
          })
          .catch(error => {
            // 处理请求失败的情况
            ElMessage({
              type: 'error',
              message: '退出登录失败: ' + error.message,
            });
          });
      }).catch(() => {
        // 这里处理取消操作，可以为空，表示用户取消了退出操作
      });
    }
  }
}
</script>

<style scoped>

</style>